import { Col, Row } from "react-bootstrap";
import moment from "moment";
import { DAY_MONTH_YEAR, TIME_FORMAT } from "constants/date";
import { DataLabel } from "components/CommonUI";

export default function AppointmentInfo({
  appointmentInfo,
  location,
  contactNo,
  notes,
  address
}) {
  return (
    <div className="offset-md-2 col-md-8 my-3">
      <div className="row d-flex justify-content-center text-muted mx-auto">
        <Row className="mb-2">
          <Col xs={12}>
            <h4 className="title__sub_section">Appointment Details</h4>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col lg={6} md={12}>
            <DataLabel label={"NRIC / FIN"} data={appointmentInfo.idNo} />
          </Col>
          {contactNo && (
            <Col lg={6} md={12}>
              <DataLabel
                label={"Singapore-registered Mobile Number"}
                data={contactNo}
              />
            </Col>
          )}
        </Row>
        <Row className="mb-3">
          <Col lg={6} md={12}>
            <DataLabel label={"Category"} data={appointmentInfo.scheme} />
          </Col>
          <Col lg={6} md={12} className="mt-3 mt-lg-0">
            <DataLabel
              label={"Mode of appointment"}
              data={appointmentInfo.mode}
            />
          </Col>
        </Row>
        {location && (
          <Row className="mb-3">
            <Col lg={6} md={12}>
              <DataLabel
                label={"Service centre"}
                data={location.info1}
                // extra={"45 Maxwell Rd, #01-11, Singapore 069118"}
                extra={address}
              />
              {/* <div>
                <strong>Location</strong>
              </div>
              <div>{location.info1}</div>
              <div>{location.info2}</div>
              <div>{location.info3}</div>
              <div>{location.info4}</div>
              <div>{location.info5}</div> */}
            </Col>
          </Row>
        )}

        {/* {appointmentInfo.bookingTxnId && (
          <Row className="mb-3">
            <Col lg={6} md={12}>
              <div>
                <strong>Booking Txn Id</strong>
              </div>
              <div>{appointmentInfo.bookingTxnId}</div>
            </Col>
            <Col lg={6} md={12}></Col>
          </Row>
        )} */}
        {notes && (
          <Row className="mb-3">
            <Col>
              <div>
                <strong>Notes</strong>
              </div>
              <div>{notes}</div>
            </Col>
          </Row>
        )}

        <Row className="mb-3">
          <Col lg={6} md={12}>
            <DataLabel
              label={"Date"}
              data={moment(appointmentInfo.date).format(DAY_MONTH_YEAR)}
            />
          </Col>
          <Col lg={6} md={12} className="mt-3 mt-lg-0">
            <DataLabel
              label={"Time"}
              data={moment(appointmentInfo.time, "H:mmA").format(TIME_FORMAT)}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}
